export default "__VITE_ASSET__DnYAsUAy__"